module.exports = __webpack_public_path__ + "img/dashboard-truck-document.11e715fa.svg";